// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"09321e67","453":"a486b8c5"}[chunkId] + ".chunk.js";
};